// extracted by mini-css-extract-plugin
module.exports = {"root":"SubscriptionAdviceBanner_root__2G6oB","text":"SubscriptionAdviceBanner_text__1eehD","button":"SubscriptionAdviceBanner_button__3Sgy8"};